import { promoteText, goodsTypeList } from '@/utils/newDataMap/shopManage';
export const configList = [
	{
		label: '推广状态',
		key: 'other_status',
		type: 'select',
		placeholder: '请选择',
		options: promoteText,
		isShow: true,
		clearable: true,
		filterable: true,
		multiple: false,
	},
	{
		label: '招商运营',
		key: 'bd_user_ids',
		type: 'component',
		component: () => import('@/components/zsPartnerSelect/index.vue'),
		isShow: true,
		collapseTags: true,
		multiple: true,
	},
	{
		label: '商品标签',
		key: 'tag_ids',
		type: 'component',
		component: () => import('@/components/business/tagSelect'),
		isShow: true,
		collapseTags: true,
		multiple: true,
	},
	{
		label: '商品类型',
		key: 'product_type',
		type: 'select',
		placeholder: '请选择',
		options: goodsTypeList,
		isShow: true,
		clearable: true,
		filterable: true,
		multiple: false,
	},
	{
		label: '团长',
		key: 'authority_id',
		type: 'component',
		component: () => import('@/components/commanderSelect/index.vue'),
		isShow: true,
	},
	{
		label: '展示样式',
		key: 'show_style',
		type: 'radio',
		options: [
			{
				label: '大图',
				value: 0,
			},
			{
				label: '列表',
				value: 1,
			},
		],
		isShow: true,
	},
	{
		label: '排序规则',
		key: 'sort_type',
		type: 'radio',
		options: [
			{
				label: '综合排序',
				value: 0,
			},
			{
				label: '上新时间',
				value: 1,
			},
		],
		isShow: true,
	},
];
